import { createFeature, createReducer, on } from '@ngrx/store';
import { EvaluateSurveyResponse } from '../../services';
import { evaluateSurveyAction } from './evaluate-survey.actions';

export const evaluateSurveyFeatureKey = 'evaluate-survey';

export const EvaluateSurveyDisplay = {
  survey: 'survey',
  submitting: 'submitting',
  result: 'result',
  error: 'error',
} as const;

export type EvaluateSurveyDisplayType =
  (typeof EvaluateSurveyDisplay)[keyof typeof EvaluateSurveyDisplay];

export interface EvaluateSurveyState {
  display: EvaluateSurveyDisplayType;
  response: EvaluateSurveyResponse | null;
}
export const initialState: EvaluateSurveyState = {
  display: EvaluateSurveyDisplay.survey,
  response: null,
};

export const reducer = createReducer(
  initialState,

  on(evaluateSurveyAction.submitAnswer, (state) => {
    return {
      ...state,
      display: EvaluateSurveyDisplay.submitting,
      resultContent: null,
    };
  }),

  on(evaluateSurveyAction.submitAnswerSuccess, (state, { response }) => {
    return {
      ...state,
      display: EvaluateSurveyDisplay.result,
      response,
    };
  }),

  on(evaluateSurveyAction.submitAnswerError, (state) => {
    return {
      ...state,
      display: EvaluateSurveyDisplay.error,
      resultContent: null,
    };
  })
);

export const evaluateSurveyFeature = createFeature({
  name: evaluateSurveyFeatureKey,
  reducer,
});
